import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots } from "vue"

import { computed } from 'vue';
import RcButton from '@components/RcButton/RcButton.vue';
import RcDropdown from '@components/RcDropdown/RcDropdown.vue';
import RcDropdownTrigger from '@components/RcDropdown/RcDropdownTrigger.vue';
import RcDropdownItem from '@components/RcDropdown/RcDropdownItem.vue';
import RcIcon from '@components/RcIcon/RcIcon.vue';

import type { RcSectionActionsProps } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcSectionActions',
  props: {
    actions: {}
  },
  setup(__props: any) {

const props = __props;

const primaryActions = computed(() => (props.actions.length < 3 ? props.actions : props.actions.slice(0, 2)));

const overflowActions = computed(() => (props.actions.length < 3 ? [] : props.actions.slice(2)));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryActions.value, (action, index) => {
      return (_openBlock(), _createBlock(RcButton, {
        key: index,
        class: _normalizeClass({ 'icon-action': !action.label }),
        variant: "link",
        size: "medium",
        "left-icon": action.label && action.icon ? (action.icon as any) : undefined,
        "aria-label": action.ariaLabel,
        onClick: _withModifiers(action.action, ["stop"])
      }, {
        default: _withCtx(() => [
          (!action.label && action.icon)
            ? (_openBlock(), _createBlock(RcIcon, {
                key: 0,
                type: action.icon as any,
                size: "medium"
              }, null, 8, ["type"]))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createTextVNode()),
          (action.label)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(action.label), 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 2
      }, 1032, ["class", "left-icon", "aria-label", "onClick"]))
    }), 128)),
    _cache[3] || (_cache[3] = _createTextVNode()),
    (overflowActions.value.length)
      ? (_openBlock(), _createBlock(RcDropdown, {
          key: 0,
          placement: "bottom-end",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, {
          dropdownCollection: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(overflowActions.value, (action, index) => {
              return (_openBlock(), _createBlock(RcDropdownItem, {
                key: index,
                "aria-label": action.ariaLabel,
                onClick: _withModifiers(action.action, ["stop"])
              }, _createSlots({
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(action.label), 1)
                ]),
                _: 2
              }, [
                (action.icon)
                  ? {
                      name: "before",
                      fn: _withCtx(() => [
                        _createVNode(RcIcon, {
                          type: action.icon as any,
                          size: "small"
                        }, null, 8, ["type"])
                      ]),
                      key: "0"
                    }
                  : undefined
              ]), 1032, ["aria-label", "onClick"]))
            }), 128))
          ]),
          default: _withCtx(() => [
            _createVNode(RcDropdownTrigger, {
              class: "icon-action",
              variant: "link",
              size: "medium",
              "aria-label": "More actions"
            }, {
              default: _withCtx(() => [
                _createVNode(RcIcon, {
                  type: "actions",
                  size: "medium"
                })
              ]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createTextVNode())
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})